import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div className='container'>
            <td>
                 <NavLink to='/category/Interview question/3'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page  → </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Interview question/1'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>← Previous page </Button>
</NavLink>

<div class="concepts">
<a > Aptitude Concepts</a>
</div>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>Compound Intrest</b></h3>
</div>

<br /> <br /> <br /> <br /> <br /> <br />

<br />
<p class="pq">1) What is the compound interest on Rs. 2500 for 2 years at rate of interest 4% per annum?</p> 
<ol class="pointsu">
<li className='list'>Rs. 180</li>                                                            
<li className='list'>Rs. 204</li>
<li className='list'>Rs. 210</li>                                                            
<li className='list'>Rs. 220</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p>The Correct answer is (B)</p>
<p><strong>Explanation:</strong></p>
<p>Principal (P) = Rs. 2500</p>
<p>Rate of interest(r) = 4%</p>
<p>Time (t) = 2 years</p>
<p>Compound Interest = Amount - Principal<br/>
<img src="https://static.javatpoint.com/aptitude/images/compound-interest-test-paper-q1.png" alt="Apti Compound Interest"/></p>
</div></Collapsible>

<br />

<p class="pq">2) What is the amount for a sum of money Rs.7500 at 6% rate of interest C.I. for 2 years?</p>
<ol class="pointsu">
<li className='list'>Rs. 8427</li>                                                    
<li className='list'>Rs. 8417</li>
<li className='list'>Rs. 8400</li>                                                    
<li className='list'>Rs. 8390</li>   
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'>
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>Principal = Rs. 7500</p>
<p>r = 6%</p>
<p>t = 2 years<br/>
<img src="https://static.javatpoint.com/aptitude/images/compound-interest-test-paper-q2.png" alt="Apti Compound Interest"/></p> 
</div></Collapsible>
<br />

<p class="pq">3) On lending a certain sum of money on C.I. one gets Rs.9050 in 2 years and Rs.9500 in 3 years. What is the rate of interest?</p>
<ol class="pointsu">
<li className='list'>5%</li>                                                         
<li className='list'>4.5%</li>
<li className='list'>5.5 %</li>                                                       
<li className='list'>6%</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'>
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>Amount after 3 years = Rs. 9500</p>
<p>Amount after 2 years = Rs. 9050</p>
<p>Interest of one year= 9500 - 9050 = 450</p>
<p>t = 1 year</p>
<p><img src="https://static.javatpoint.com/aptitude/images/compound-interest30.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest30"/></p>
<p><strong>Solution 2: Quicker Method</strong></p>
<p><strong>Apply formula;</strong> Rate of interest(r): <img src="https://static.javatpoint.com/aptitude/images/compound-interest32.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest32"/></p>
<p>Y= Rs. 9500</p>
<p>X = 9050</p>
<p><img src="https://static.javatpoint.com/aptitude/images/compound-interest33.png" alt="Apti Compound interest33"/></p>
</div></Collapsible>
<br />

<p class="pq">4) Ramesh borrowed Rs. 3600 at a certain rate of interest C.I. and the sum grows to Rs. 4624 in 2 years. What is the rate of interest? </p>
<ol class="pointsu">
<li className='list'>12.3%</li>                                                          
<li className='list'>13.3%</li>
<li className='list'>14.3%</li>                                                           
<li className='list'>15.3%</li>  
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The Correct answer is (B)</p>
<p><strong>Explanation:</strong></p>
<p>Principal = Rs. 3600</p>
<p>Amount = Rs. 4624</p> 
<p>t = 2 years</p>
<p>We have;</p>
<p><img src="https://static.javatpoint.com/aptitude/images/compound-interest35.png" alt="Apti Compound interest35"/></p>
</div></Collapsible>
<br />

<p class="pq">5) On a certain sum of money the compound interest Rs. 318 is earned in 2 years.  If the rate of interest is 12%, what is the principal amount?</p>
<ol class="pointsu">
<li className='list'>Rs. 1250</li>                                                   
<li className='list'>Rs.1300</li>
<li className='list'>Rs. 1200</li>                                                   
<li className='list'>Rs. 1150</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>We have;</p>
<p>C.I. = Rs. 318</p>
<p>r = 12%</p>
<p>t = 2 years</p>
<p><img src="https://static.javatpoint.com/aptitude/images/compound-interest36.png" alt="Apti Compound interest36"/></p>
</div></Collapsible>
<br />



<p class="pq">6) The simple interest on a certain sum of money at rate of interest 5% per annum for 2 years is Rs. 500. What is the compound interest on the same sum for the same period and at the same rate of interest?</p>
<ol class="pointsu">
<li className='list'>Rs.412.5</li>                                              
<li className='list'>Rs.400</li>
<li className='list'>Rs.500</li>                                                  
<li className='list'>Rs.512.5</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'>

<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p>The Correct answer is (D)</p>
<p><strong>Explanation:</strong></p>
<p>S.I. = 500</p>
<p>r = 5%</p>
<p>t = 2 years</p>
<p>Before finding C.I. we have to find the sum or principal;</p>
<p><strong>Apply formula; Principal =</strong> <img src="https://static.javatpoint.com/aptitude/images/compound-interest37.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest37"/><br/>
Principal = <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q6.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest38"/>= Rs. 5000 </p> 
<p>Now we have to find the Amount;</p>
<p><strong>Apply formula; Amount</strong> =<img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q6_2.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest39"/></p> 
<p>Amount = 5000 <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q6_3.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest"/></p> 
<p><img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q6_4.png" alt="Apti Compound interest"/></p>
<p>= 5000 * 1.05 * 1.05 = Rs. 5512.5</p>
<p><strong>C.I. = Amount - Principal</strong></p>
<p>C.I. = 5512.5 - 5000 = Rs. 512.5 (Option D)</p>
</div> </Collapsible>
<br />

<p class="pq">7) In how many years the compound interest on Rs. 10000 at the rate of 10% will be Rs. 2100 ?</p>
<ol class="pointsu">
<li className='list'>1.5 years</li>                                            
<li className='list'>2 years</li> 
<li className='list'>2.5 years</li>                                            
<li className='list'>3 years</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'>

<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p>The Correct answer is (B)</p>
<p><strong>Explanation:</strong></p>
<p>Principal = Rs. 10000</p> 
<p>r = 10%</p>
<p>C.I. = Rs. 2100</p>
<p><img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q7.png" alt="Apti Compound interest"/></p>
</div> </Collapsible>
<br />

<p class="pq">8) The difference between Simple Interest and Compound Interest on a certain sum of money for 2 years is Rs.200. If the rate of interest is 12 <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q8.png" style={{margin:'5px 4px -18px 0'}} alt="Apti Compound interest43"/>%, what is the sum?</p>
<ol class="pointsu">
<li className='list'>Rs. 11800</li>                                             
<li className='list'>Rs. 12000</li>
<li className='list'>Rs. 12800</li>                                              
<li className='list'>Rs. 13000</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'>

<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p>The Correct answer is (C)</p>
<p><strong>Explanation:</strong></p>
<p>If the difference between the C.I. and S.I. on a certain sum of money for 2 years at rate of interest r % is Rs. X, then the sum is given by;</p>
<p><strong>Sum = X</strong><img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q8_1.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest"/></p>
<p>We have;</p>
<p>X = Rs. 200</p>
<p>t = 2 years</p>
<p>r = 12 <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q8_2.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest"/><br/>
Therefore, Sum = 200 <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q8_3.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest"/></p>

<p>= 200 * <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q8_4.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest"/></p>
<p>= 200 * <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q8_5.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest"/> * <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q8_5.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest"/></p>
<p>= 200 * 64</p>
<p>= Rs. 12800 (Option C)</p>
</div> </Collapsible>
<br />

<p class="pq">9) If the difference between Simple Interest and Compound Interest on a sum of money for 3 years is Rs. 200 and the rate of interest is 10%, what is the sum?</p>
<ol class="pointsu">
<li className='list'>Rs. 6451.6</li>                                                
<li className='list'>Rs. 6351.6</li>
<li className='list'>Rs. 6251.6</li>                                                 
<li className='list'>Rs. 6151.6</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'>

<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p>The Correct answer is (A)</p>
<p><strong>Explanation:</strong></p>
<p>If the difference between C.I. and S.I. on a certain sum for 3 years at rate of interest r% is Rs. X, then the sum is given by;</p>
<p><strong>Sum</strong> = <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q9.png" style={{margin:'5px 4px -18px 0'}} alt="Apti Compound interest"/></p>
<p>We have;</p>
<p>X = Rs. 200</p>
<p>r = 10%<br/>
Therefore, sum = <img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q9_2.png" style={{margin:'5px 4px -15px 0'}} alt="Apti Compound interest"/></p>
<img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q9_3.png" alt="Apti Compound interest"/>
</div> </Collapsible>
<br />

<p class="pq">10) The difference between simple interest and compound interest on a sum of money for 1 year at 4% per 6 months is 4, what is the sum?</p>
<ol class="pointsu">
<li className='list'>Rs. 2100</li>                                                  
<li className='list'>Rs. 2300</li>
<li className='list'>Rs. 2500</li>                                                  
<li className='list'>Rs. 3000</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'>

<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p>The Correct answer is (C)</p>
<p><strong>Explanation:</strong></p>
<p>Let the sum = Rs. X</p>
<p>t = 1 year = 2 half years (6 months)</p>
<p>r = 4% for 6 months</p>
<p><img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q10.png" alt="Apti Compound interest48"/></p>
<p><img src="https://static.javatpoint.com/aptitude/images/compound-interest-aptitude-q10_2.png" alt="Apti Compound interest"/></p>
</div> </Collapsible>
<br />



</td>
      </div>  
    )
}

export default Iq2
